  const tilesGrid = document.querySelector('.tiles-grid');
  if (tilesGrid) {
    const tiles = tilesGrid.querySelectorAll('.tile-link');
    gsap.from(tiles, {
      opacity: 0,
      y: 50,
      scale: 0.97,
      duration: 1.2,
      stagger: 0.25,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: tilesGrid,
        start: 'top 82%',
        once: true
      }
    });
  }


  // ─── ABOUT PAGE ───────────────────────────────────────────────────────────
if (document.querySelector('.about')) {

  gsap.registerPlugin(ScrollTrigger);

  // H1 naslov
  gsap.from('.about__h1', {
    opacity: 0,
    y: 40,
    duration: 1.2,
    ease: 'power3.out'
  });

  // Svaki grid red
  document.querySelectorAll('.about__grid--split').forEach(grid => {
    gsap.from(grid.children, {
      opacity: 0,
      y: 50,
      duration: 1.0,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: grid,
        start: 'top 80%',
        once: true
      }
    });
  });

  // Values
  gsap.from('.val', {
    opacity: 0,
    y: 30,
    duration: 0.8,
    stagger: 0.2,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.vals',
      start: 'top 80%',
      once: true
    }
  });

  // Citat
  gsap.from('.about__quote', {
    opacity: 0,
    y: 25,
    duration: 1.0,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.about__quote',
      start: 'top 85%',
      once: true
    }
  });

  // Founder band
  gsap.from('.founder--band', {
    opacity: 0,
    y: 40,
    duration: 1.0,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.founder--band',
      start: 'top 80%',
      once: true
    }
  });

  // Timeline kartice
  gsap.from('.tcard', {
    opacity: 0,
    y: 35,
    duration: 0.7,
    stagger: 0.15,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.timeline',
      start: 'top 85%',
      once: true
    }
  });
}

// ─── MNMLST PAGE ──────────────────────────────────────────────────────────
if (document.querySelector('.three-tiles, .split-ic, .simple-cta, .coll-tabs')) {

  gsap.registerPlugin(ScrollTrigger);

  // 1. Three image tiles — stagger
  const tilesGrid = document.querySelector('.three-tiles__grid');
  if (tilesGrid) {
    gsap.from(tilesGrid.querySelectorAll('.three-tiles__tile'), {
      opacity: 0,
      y: 50,
      duration: 1.0,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: tilesGrid,
        start: 'top 85%',
        once: true
      }
    });
  }

 // 2. Collection tabs naslov + tabovi + kartice
const collTabs = document.querySelector('.coll-tabs');
if (collTabs) {
  const tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: collTabs,
      start: 'top 85%',
      once: true
    }
  });

  tl2.from('.coll-tabs__title', {
    opacity: 0,
    y: 25,
    duration: 0.9,
    ease: 'power2.out'
  })
  .from('.coll-tabs__tab', {
    opacity: 0,
    y: 15,
    duration: 0.7,
    stagger: 0.1,
    ease: 'power2.out'
  }, '-=0.5')
  .from('.coll-tabs__panel.is-active .coll-tabs__card', {
    opacity: 0,
    x: 40,
    duration: 0.7,
    stagger: 0.08,
    ease: 'power2.out',
    clearProps: 'all'
  }, '-=0.3');
}

  // 3. Split image content — slika s leva, tekst s desna
  const splitIc = document.querySelector('.split-ic');
  if (splitIc) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: splitIc,
        start: 'top 80%',
        once: true
      }
    });
    tl.from('.split-ic__media', {
      opacity: 0,
      x: -40,
      duration: 1.0,
      ease: 'power2.out',
      clearProps: 'all'
    })
    .from(['.split-ic__heading', '.split-ic__text', '.split-ic__btn'], {
      opacity: 0,
      x: 30,
      duration: 0.9,
      stagger: 0.15,
      ease: 'power2.out',
      clearProps: 'all'
    }, '-=0.6');
  }

  // 4. Simple center CTA
  const simpleCta = document.querySelector('.simple-cta');
  if (simpleCta) {
    gsap.from(['.simple-cta__heading', '.simple-cta__link'], {
      opacity: 0,
      y: 30,
      duration: 1.0,
      stagger: 0.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: simpleCta,
        start: 'top 85%',
        once: true
      }
    });
  }

}


// ─── FOOTER — svuda ───────────────────────────────────────────────────────
const footerWrapper = document.querySelector('.footer-custom-wrapper');
if (footerWrapper) {
  gsap.from(footerWrapper.querySelectorAll('.footer-col'), {
    opacity: 0,
    y: 25,
    duration: 1.25,
    stagger: 0.25,
    ease: 'power2.out',
    clearProps: 'all',
    scrollTrigger: {
      trigger: footerWrapper,
      start: 'top 95%',
      once: true
    }
  });
}


const headerComponent = document.querySelector('header-component');
if (headerComponent) {
  const tlNav = gsap.timeline({ delay: 0.1 });

  const navLinks = gsap.utils.toArray('.menu-list__link').filter(el => 
    !el.closest('[slot="more"]') && !el.closest('[slot="overflow"]')
  );

  tlNav.from('.header-logo', {
    opacity: 0,
    y: -12,
    duration: 0.7,
    ease: 'power2.out'
  })
  .from(navLinks, {
    opacity: 0,
    y: -8,
    duration: 0.5,
    stagger: 0.06,
    ease: 'power2.out',
    onComplete: () => {
      // Nakon animacije, resetuj overflow linkove
      gsap.utils.toArray('.menu-list__link').forEach(el => {
        if (el.closest('[slot="more"]') || el.closest('[slot="overflow"]')) {
          gsap.set(el, { clearProps: 'all' });
        }
      });
    }
  }, '-=0.3')
  .from('header-actions', {
    opacity: 0,
    y: -8,
    duration: 0.5,
    ease: 'power2.out'
  }, '-=0.3');
}

// ─── WHERE TO SHOP PAGE ───────────────────────────────────────────────────
const rotWts = document.querySelector('.rot-wts');
if (rotWts) {

  // Hero slika
  gsap.from('.rot-wts__hero-img', {
    opacity: 0,
    scale: 1.05,
    duration: 1.2,
    ease: 'power2.out'
  });

  // Naslov
  gsap.from('.rot-wts__title', {
    opacity: 0,
    y: 30,
    duration: 1.0,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.rot-wts__title',
      start: 'top 85%',
      once: true
    }
  });

  // Store kartice — stagger
  gsap.from('.rot-card', {
    opacity: 0,
    y: 40,
    duration: 0.7,
    stagger: 0.12,
    ease: 'power2.out',
    clearProps: 'all',
    scrollTrigger: {
      trigger: '.rot-wts__grid',
      start: 'top 85%',
      once: true
    }
  });

}